import "./vendor.scss";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { useEffect, useMemo, useState } from "react";
import { getDashboardInfo } from "@services/vendors.service";
import moment from "moment";
import { useNavigate } from "react-router-dom";
// import DatePicker from "react-date-picker";
import { getValue } from "@utils/lodash";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import "chartjs-plugin-datalabels";
import ChartDataLabels from "chartjs-plugin-datalabels";
import InputField from "@_common/InputRuleFeild";
import {
  adminGetCountriesListManagement,
  adminGetStatesListManagement,
} from "@services/list-management.service";
import { monthsString } from "@_common/month";
import { CheckDecimal } from "@_common/check-decimal";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import { formatDecimal, textCapitalize } from "@_common/text-helpers";
import { toast } from "react-toastify";
import Loader from "@components/common/Loader";
import ExpandableTable from "@components/Dashboard/ExpandableTable/index";
import CalenderDropdown from "@_common/CalenderDropdown";
import { convertCurrentDate, currentDate } from "@_common/date-helpers";
import {
  exportAuditUploadLocation,
  exportAuditUploadVendor,
} from "@services/dashboard.service";
import DashboardSvgComponent from "../../../assets/svg-components/left-menu/dashboard";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);
export default function VendorAudits(props: any) {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  /* -------------------------------------------------------------------------- */
  /*                         usestate Section                                   */
  /* -------------------------------------------------------------------------- */
  const [summaryInfo, setSummaryInfo] = useState({});
  const [overViewInfo, setOverviewInfo] = useState({});
  const [countryList, setCountryList] = useState([]);
  const [states, setStates] = useState([]);
  const [country_id, setCountry_id] = useState<any>();
  const [state_id, setState_id] = useState<any>();
  const [vendorsByLocation, setVendorsByLocation] = useState([]);
  const [auditUploadLocations, setAuditUploadLocations] = useState([]);
  const [auditUploadVendor, setAuditUploadVendor] = useState([]);
  const [locationsByVendor, setLocationsByVendor] = useState([]);
  const [date, setDate] = useState<Date | null>(null);
  /* -------------------------------------------------------------------------- */
  /*                        Useeffect Section                                   */
  /* -------------------------------------------------------------------------- */
  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getOverviewData();
      getSummaryData();
      getCatrgoryData();
      getAuditUploadLcoationData();
      getAuditUploadVendorData();
      getCountriesList();
      if (params.country_id) {
        setCountry_id(parseInt(params.country_id));
      } else {
        setCountry_id(101);
      }
      if (params.state_id) {
        setState_id(parseInt(params.state_id));
      } else {
        setState_id(4026);
      }
      setDate(new Date());
    }
  }, [props.permissionAPITriggered]);
  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getOverviewData();
      getCountriesList();
      getSummaryData();
      getCatrgoryData();
      getAuditUploadLcoationData();
      getAuditUploadVendorData();
      if (params.date) {
        setDate(new Date(params.date));
      } else {
        setDate(new Date());
      }
      if (params.country_id) {
        setCountry_id(parseInt(params.country_id));
        //con
        getStatesList(parseInt(params.country_id));
      } else {
        setCountry_id(101);
      }
      if (params.state_id) {
        setState_id(parseInt(params.state_id));
        //cond
        getLocationData(parseInt(params.state_id));
        getMonthData();
      } else {
        setState_id(4026);
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  useEffect(() => {
    if (country_id && state_id && props.permissionAPITriggered) {
      getLocationData(state_id);
      getMonthData();
    }
    if (country_id) {
      getStatesList(country_id);
    }
  }, [country_id, state_id, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                              API Section                                   */
  /* -------------------------------------------------------------------------- */
  const getCountriesList = async () => {
    try {
      let resp = await adminGetCountriesListManagement();
      if (resp) {
        setCountryList(
          getValue(resp, `data.countries`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `name`, ""),
            label: getValue(item, `name`, ""),
          }))
        );
      } else {
      }
    } catch (error) {}
  };
  const getStatesList = async (countryId: number) => {
    if (countryId) {
      try {
        let resp = await adminGetStatesListManagement(countryId);
        if (resp) {
          setStates(
            getValue(resp, `data.states`, []).map((item: object) => ({
              ...item,
              value: getValue(item, `name`, ""),
              label: getValue(item, `name`, ""),
            }))
          );
        } else {
        }
      } catch (error) {}
    }
  };
  const handleChangeSelect = (e: any, type: string) => {
    if (type === "country_id") {
      getStatesList(e.id);
      setStates([]);
    }
    if (type === "state_id") {
      setState_id(e.id);
      setData({
        ...data,
        labels: "",
        datasets: [
          {
            label: "Temp Loc",
            data: [0, 0],
            backgroundColor: "rgba(255, 99, 132, 0.5)",
            barThickness: 10,
          },
        ],
      });
      let payload: any = {
        state_id: e.id,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      // getLocationData(e.id);
    }
  };
  const getOverviewData = async () => {
    try {
      let payload = {
        type: "OVERVIEW",
      };
      setIsLoading(true);
      let resp = await getDashboardInfo(payload);
      if (resp) {
        setOverviewInfo(getValue(resp, `data.overview`, {}));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };
  const getSummaryData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? parseInt(params.date.split("-")[1])
          : date
          ? parseInt(moment(date).format("M"))
          : parseInt(moment(dates).format("M")),
        year: params.date
          ? parseInt(params.date.split("-")[0])
          : date
          ? parseInt(moment(date).format("YYYY"))
          : parseInt(moment(dates).format("YYYY")),
        type: "SUMMERY",
      };
      let resp = await getDashboardInfo(payload);
      if (resp) {
        setSummaryInfo(getValue(resp, `data`, {}));
      }
    } catch (error) {}
  };
  const getLocationData = async (id: any) => {
    if (country_id) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let dates = date ? date : new Date();
      try {
        let payload = {
          month: params.date
            ? parseInt(params.date.split("-")[1])
            : date
            ? parseInt(moment(date).format("M"))
            : parseInt(moment(dates).format("M")),
          year: params.date
            ? parseInt(params.date.split("-")[0])
            : date
            ? parseInt(moment(date).format("YYYY"))
            : parseInt(moment(dates).format("YYYY")),
          country_id: country_id,
          state_id: id,
          type: "LOCATION",
        };
        let resp = await getDashboardInfo(payload);
        if (resp) {
          if (getValue(resp, `data.length`, 0) > 0) {
            let labels: any = [];
            labels =
              getValue(resp, `data.length`, 0) > 0
                ? getValue(resp, `data`, []).map((item: any) =>
                    Object.keys(item)
                  )
                : [];
            let finalLabels = [].concat(...labels);
            let complaince_data: any = [];
            let non_complaince_data: any = [];
            for (let i = 0; i < getValue(resp, `data.length`, 0); i++) {
              complaince_data.push(
                CheckDecimal(
                  getValue(resp, `data[${i}]${labels[i]}.compliance_score`, 0)
                )
              );
              non_complaince_data.push(
                CheckDecimal(
                  getValue(
                    resp,
                    `data[${i}]${labels[i]}.non_compliance_score`,
                    0
                  )
                )
              );
            }
            setData({
              ...data,
              labels: getValue(finalLabels, `length`, 0) > 0 ? finalLabels : [],
              datasets: [
                {
                  label: "Non-Compliant",
                  data: non_complaince_data,
                  backgroundColor: "#E8F0FE",
                  barThickness: 70,
                },
                {
                  label: "Compliant",
                  data: complaince_data,
                  backgroundColor: "#72A4F7",
                  barThickness: 70,
                },
              ],
            });
          } else {
            setData({
              ...data,
              labels: [""],
              datasets: [
                {
                  label: "",
                  data: [0, 0],
                  backgroundColor: "rgba(255, 99, 132, 0.5)",
                  barThickness: 10,
                },
              ],
            });
          }
        }
      } catch (error) {}
    }
  };
  const getMonthData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        year: params.date
          ? parseInt(params.date.split("-")[0])
          : date
          ? parseInt(moment(date).format("YYYY"))
          : parseInt(moment(dates).format("YYYY")),
        // country_id: country_id,
        // state_id: state_id,
        type: "MONTH",
      };
      let resp = await getDashboardInfo(payload);
      if (resp) {
        if (getValue(resp, `data.length`, 0) > 0) {
          let labels: any = [];
          labels =
            getValue(resp, `data.length`, 0) > 0 &&
            getValue(resp, `data`, []).map((item: any) => Object.keys(item));
          let finalLabels = [].concat(...labels);
          let complaince_data: any = [];
          let non_complaince_data: any = [];
          for (let i = 0; i < getValue(resp, `data.length`, 0); i++) {
            complaince_data.push(
              CheckDecimal(
                getValue(resp, `data[${i}]${labels[i]}.compliance_score`, 0)
              )
            );
            non_complaince_data.push(
              CheckDecimal(
                getValue(resp, `data[${i}]${labels[i]}.non_compliance_score`, 0)
              )
            );
          }
          let formatedMonths = finalLabels.map((item) => {
            let year = params.date
              ? parseInt(params.date.split("-")[2])
              : date
              ? parseInt(moment(date).format("YY"))
              : parseInt(moment(dates).format("YY"));
            return `${monthsString[parseInt(item)]}-${year}`;
          });
          setMonthData({
            ...monthData,
            labels:
              getValue(formatedMonths, `length`, 0) > 0 ? formatedMonths : [],
            datasets: [
              {
                label: "Non-Compliant",
                data: non_complaince_data,
                backgroundColor: "#E8F0FE",
                barThickness: 70,
              },
              {
                label: "Compliant",
                data: complaince_data,
                backgroundColor: "#72A4F7",
                barThickness: 70,
              },
            ],
          });
        } else {
          setMonthData({
            ...monthData,
            labels: [""],
            datasets: [
              {
                label: "",
                data: [0, 0],
                backgroundColor: "rgba(255, 99, 132, 0.5)",
                barThickness: 10,
              },
            ],
          });
        }
      }
    } catch (error) {}
  };
  const getCatrgoryData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    try {
      let payload = {
        month: params.date
          ? parseInt(params.date.split("-")[1])
          : date
          ? parseInt(moment(date).format("M"))
          : parseInt(moment(dates).format("M")),
        year: params.date
          ? parseInt(params.date.split("-")[0])
          : date
          ? parseInt(moment(date).format("YYYY"))
          : parseInt(moment(dates).format("YYYY")),
        type: "CATEGORY",
      };
      let resp = await getDashboardInfo(payload);
      if (resp) {
        if (getValue(resp, `data.length`, 0) > 0) {
          let labels: any = [];
          labels =
            getValue(resp, `data.length`, 0) > 0 &&
            getValue(resp, `data`, []).map((item: any) => Object.keys(item));
          let finalLabels = [].concat(...labels);
          let complaince_data: any = [];
          let non_complaince_data: any = [];
          for (let i = 0; i < getValue(resp, `data.length`, 0); i++) {
            complaince_data.push(
              CheckDecimal(
                getValue(resp, `data[${i}]${labels[i]}.compliance_score`, 0)
              )
            );
            non_complaince_data.push(
              CheckDecimal(
                getValue(resp, `data[${i}]${labels[i]}.non_compliance_score`, 0)
              )
            );
          }
          setCategoryData({
            ...categoryData,
            labels: getValue(finalLabels, `length`, 0) > 0 ? finalLabels : [],
            datasets: [
              {
                label: "Non-Compliant",
                data: non_complaince_data,
                backgroundColor: "#E8F0FE",
                barThickness: 70,
              },
              {
                label: "Compliant",
                data: complaince_data,
                backgroundColor: "#72A4F7",
                barThickness: 70,
              },
            ],
          });
        } else {
          setCategoryData({
            ...categoryData,
            labels: [""],
            datasets: [
              {
                label: "",
                data: [0, 0],
                backgroundColor: "rgba(255, 99, 132, 0.5)",
                barThickness: 10,
              },
            ],
          });
        }
      }
    } catch (error) {}
  };
  const getAuditUploadLcoationData = async () => {
    try {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let dates = date ? date : new Date();
      let payload = {
        month: params.date
          ? parseInt(params.date.split("-")[1])
          : date
          ? parseInt(moment(date).format("M"))
          : parseInt(moment(dates).format("M")),
        year: params.date
          ? parseInt(params.date.split("-")[0])
          : date
          ? parseInt(moment(date).format("YYYY"))
          : parseInt(moment(dates).format("YYYY")),
        type: "AUDIT_UPLOAD_LOCATION",
      };
      let resp = await getDashboardInfo(payload);
      if (resp) {
        setAuditUploadLocations(
          getValue(resp, `data`, []).map((item: any) => ({
            id: Object.keys(item)[0].split("::")[0],
            location:
              Object.entries(item).length > 0
                ? Object.entries(item)[0][0].split("::")[1]
                : "",
            auditData: item[Object.entries(item)[0][0]],
          }))
        );
      }
    } catch (error) {}
  };
  const getAuditUploadLcoationVendorData = async (id: string) => {
    if (id) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let dates = date ? date : new Date();
      try {
        let payload = {
          country_id: country_id,
          location_id: id,
          month: params.date
            ? parseInt(params.date.split("-")[1])
            : date
            ? parseInt(moment(date).format("M"))
            : parseInt(moment(dates).format("M")),
          year: params.date
            ? parseInt(params.date.split("-")[0])
            : date
            ? parseInt(moment(date).format("YYYY"))
            : parseInt(moment(dates).format("YYYY")),
          type: "AUDIT_UPLOAD_LOCATION_VENDOR",
        };
        let resp = await getDashboardInfo(payload);
        if (resp) {
          setVendorsByLocation(
            getValue(resp, `data`, []).map((item: any) => ({
              id: Object.keys(item)[0].split("::")[0],
              location:
                Object.entries(item).length > 0
                  ? Object.entries(item)[0][0].split("::")[1]
                  : "",
              auditData: item[Object.entries(item)[0][0]],
            }))
          );
        } else {
          setVendorsByLocation([]);
        }
      } catch (error) {
        setVendorsByLocation([]);
      }
    } else {
    }
  };
  const getAuditUploadVendorData = async () => {
    try {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let dates = date ? date : new Date();
      let payload = {
        month: params.date
          ? parseInt(params.date.split("-")[1])
          : date
          ? parseInt(moment(date).format("M"))
          : parseInt(moment(dates).format("M")),
        year: params.date
          ? parseInt(params.date.split("-")[0])
          : date
          ? parseInt(moment(date).format("YYYY"))
          : parseInt(moment(dates).format("YYYY")),
        type: "AUDIT_UPLOAD_VENDOR",
      };
      let resp = await getDashboardInfo(payload);
      if (resp) {
        setAuditUploadVendor(
          getValue(resp, `data`, []).map((item: any) => ({
            id: Object.keys(item)[0].split("::")[0],

            location:
              Object.entries(item).length > 0
                ? Object.entries(item)[0][0].split("::")[1]
                : "",
            auditData: item[Object.entries(item)[0][0]],
          }))
        );
      }
    } catch (error) {}
  };
  const getAuditUploadVendorCityDataInside = async (id: string) => {
    if (id) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let dates = date ? date : new Date();
      try {
        let payload = {
          country_id: country_id,
          state_id: state_id,
          vendor_id: id,
          month: params.date
            ? parseInt(params.date.split("-")[1])
            : date
            ? parseInt(moment(date).format("M"))
            : parseInt(moment(dates).format("M")),
          year: params.date
            ? parseInt(params.date.split("-")[0])
            : date
            ? parseInt(moment(date).format("YYYY"))
            : parseInt(moment(dates).format("YYYY")),
          type: "AUDIT_UPLOAD_VENDOR_LOCATION",
        };
        let resp = await getDashboardInfo(payload);
        if (resp) {
          setLocationsByVendor(
            getValue(resp, `data`, []).map((item: any) => ({
              id: Object.keys(item)[0].split("::")[0],
              location:
                Object.entries(item).length > 0
                  ? Object.entries(item)[0][0]
                  : "",
              auditData: item[Object.entries(item)[0][0]],
            }))
          );
        }
      } catch (error) {}
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                              Date Routes                                   */
  /* -------------------------------------------------------------------------- */

  const handleSubmitDate = () => {
    let dates = date && moment(date).format("YYYY-MM-DD");
    if (dates) {
      let payload: any = {
        date: dates,
        country_id: country_id,
        state_id: state_id,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      toast.error("Please confirm date");
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                              Chart Section                                 */
  /* -------------------------------------------------------------------------- */

  const options: any = {
    responsive: true,
    plugins: {
      datalabels: {
        anchor: "start",
        align: "end",
        labels: {
          value: {
            color: "black",
          },
        },
        formatter: (val: any) => {
          return val + "%";
        },
      },
      legend: {
        position: "top",
      },
      title: {
        display: false,
        text: "Chart.js Bar Chart",
      },
    },
  };

  const [data, setData] = useState<any>({
    labels: [],
    datasets: [
      {
        label: "Location 1",
        data: [0, 0],
        backgroundColor: "rgba(255, 99, 132, 0.5)",
        barThickness: 10,
      },
      {
        label: "Location 2",
        data: [0, 0],
        backgroundColor: "rgba(53, 162, 235, 0.5)",
        barThickness: 10,
      },
    ],
  });

  const [monthData, setMonthData] = useState<any>({
    labels: [],
    datasets: [
      {
        label: "Month 1",
        data: [0, 0],
        backgroundColor: "rgba(255, 99, 132, 0.5)",
        barThickness: 10,
      },
      {
        label: "Month 2",
        data: [0, 0],
        backgroundColor: "rgba(53, 162, 235, 0.5)",
        barThickness: 10,
      },
    ],
  });
  const [categoryData, setCategoryData] = useState<any>({
    labels: [],
    datasets: [
      {
        label: "Category 1",
        data: [0, 0],
        backgroundColor: "rgba(255, 99, 132, 0.5)",
        barThickness: 10,
      },
      {
        label: "Category 2",
        data: [0, 0],
        backgroundColor: "rgba(53, 162, 235, 0.5)",
        barThickness: 10,
      },
    ],
  });

  let state_ID = states.filter(
    (item: object) => getValue(item, `id`, "") == state_id
  );

  const handleNavigateLocation = () => {
    let payload = {
      is_active: true,
      sort_by: "newest",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`/configuration/locations?${queryRequest}`);
  };

  const handleNavigateVendor = () => {
    let payload = {
      vendor_type: "SERVICING_VENDOR",
      is_default: true,
      is_active: true,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`/configuration/vendors?${queryRequest}`);
  };

  const handleNavigateUpload = (type: string) => {
    let dates = date ? date : new Date();
    let payload = {};
    let queryRequest = QueryRequestHelper(payload);
    navigate(
      `/audit/details/${moment(dates).format(
        "YYYY-MM-DD"
      )}/${type}/-?${queryRequest}`
    );
  };

  const handleNavigateAudit = (type: string) => {
    let dates = date ? date : new Date();
    let payload = {};
    let queryRequest = QueryRequestHelper(payload);
    navigate(
      `/audit/details/${moment(dates).format(
        "YYYY-MM-DD"
      )}/-/${type}?${queryRequest}`
    );
  };

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  const [wageDates, setWageDates] = useState<any>({
    firstDay: null,
    lastDay: null,
  });
  useMemo(() => {
    let dates = params.date ? new Date(params.date) : new Date();
    let first = new Date(dates.getFullYear(), dates.getMonth(), 1);
    let last = new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
    setWageDates({
      ...wageDates,
      firstDay: first,
      lastDay: last,
    });
  }, [params.date]);

  /* -------------------------------------------------------------------------- */
  /*                             Download Reports                               */
  /* -------------------------------------------------------------------------- */

  /* ------------------------------- Location ---------------------------- */

  const [downloadLoading, setDownloadLoading] = useState(false);
  const handleDownloadSelfComplianceReport = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    let payload: any = {
      report_type: "AUDIT_UPLOAD_LOCATION",
      report_name: `audit_upload_location_report_${currentDate()}`,
      month: params.date
        ? parseInt(params.date.split("-")[1])
        : date
        ? parseInt(moment(date).format("M"))
        : parseInt(moment(dates).format("M")),
      year: params.date
        ? parseInt(params.date.split("-")[0])
        : date
        ? parseInt(moment(date).format("YYYY"))
        : parseInt(moment(dates).format("YYYY")),
      type: "AUDIT_UPLOAD_LOCATION",
    };
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    setDownloadLoading(true);
    try {
      let resp = await exportAuditUploadLocation({
        ...payload,
      });
      if (resp) {
        setDownloadLoading(false);
        toast.success(getValue(resp, `message`, ""));
        navigate(`/self-compliance-logs/AUDIT_UPLOAD_LOCATION`);
      } else {
        setDownloadLoading(false);
      }
    } catch (error) {
      setDownloadLoading(false);
    }
  };
  /* ------------------------------- Vendor ---------------------------- */
  const [downloadLoading1, setDownloadLoading1] = useState(false);
  const handleDownloadSelfComplianceReport1 = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    let payload: any = {
      report_type: "AUDIT_UPLOAD_VENDOR",
      report_name: `audit_upload_vendor_report_${currentDate()}`,
      month: params.date
        ? parseInt(params.date.split("-")[1])
        : date
        ? parseInt(moment(date).format("M"))
        : parseInt(moment(dates).format("M")),
      year: params.date
        ? parseInt(params.date.split("-")[0])
        : date
        ? parseInt(moment(date).format("YYYY"))
        : parseInt(moment(dates).format("YYYY")),
      type: "AUDIT_UPLOAD_VENDOR",
    };
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    setDownloadLoading1(true);
    try {
      let resp = await exportAuditUploadVendor({
        ...payload,
      });
      if (resp) {
        setDownloadLoading1(false);
        toast.success(getValue(resp, `message`, ""));
        navigate(`/self-compliance-logs/AUDIT_UPLOAD_VENDOR`);
      } else {
        setDownloadLoading1(false);
      }
    } catch (error) {
      setDownloadLoading1(false);
    }
  };
  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "dashboard_vendor_audit"
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          <div className="dashboard-wrapper__header d-flex justify-content-between align-items-center d-none">
            <h4 className="dashbaord-wrapper__header-title">Vendor Audits</h4>
            <p className="overview-wrapper__header-title">
              <span style={{ color: "#d7252e" }}>Wage Period :</span>{" "}
              <b>{`${
                getValue(wageDates, `firstDay`, null) &&
                convertCurrentDate(getValue(wageDates, `firstDay`, null))
              } - ${
                getValue(wageDates, `lastDay`, null) &&
                convertCurrentDate(getValue(wageDates, `lastDay`, null))
              }`}</b>
            </p>
          </div>
          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="header-parent-icon-holder">
                <DashboardSvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Dashboard
                </h6>
                <h4 className="dashbaord-wrapper__header-title">Vendor Audits</h4>
              </div>
            </div>

            <div className="d-flex align-items-center">
              <p className="overview-wrapper__header-title">
                <span style={{ color: "#d7252e" }}>Wage Period :</span>{" "}
                <b>{`${
                  getValue(wageDates, `firstDay`, null) &&
                  convertCurrentDate(getValue(wageDates, `firstDay`, null))
                } - ${
                  getValue(wageDates, `lastDay`, null) &&
                  convertCurrentDate(getValue(wageDates, `lastDay`, null))
                }`}</b>
              </p>
            </div>
          </div>
          {isLoading || !props.permissionAPITriggered ? (
            <Loader />
          ) : (
            <div className={`main-page-layout-wrapper main-page-layout-wrapper-dashboard`}>
              <div className="vender-audit-wrapper">
                <section className="overview-wrapper">
                  <div className="breakup-wrapper d-flex align-items-center box-gap pt-0">
                    <section
                      className={`breakup-box breakup-box--${"green-color"} breakup-box--blue-bg`}
                      onClick={() =>
                        getValue(overViewInfo, `vendor_count`, 0) > 0 &&
                        handleNavigateVendor()
                      }
                    >
                      <div className="breakup-box__details">
                        <h6 className={`breakup-box__title breakup-box__title--`}>
                          {getValue(overViewInfo, `vendor_count`, "0")}
                        </h6>
                        <p
                          className={`breakup-box__text breakup-box__text--${"blue-color"}`}
                        >
                          {textCapitalize("Vendors")}
                        </p>
                      </div>
                      <img
                        src={`/images/dashboard/vender-audit/engineering.svg`}
                        className="img-fluid breakup-box-image"
                        alt="img"
                      />
                    </section>
                    <section
                      className={`breakup-box breakup-box-- breakup-box--green-bg`}
                      onClick={() =>
                        getValue(overViewInfo, `location_count`, 0) > 0 &&
                        handleNavigateLocation()
                      }
                    >
                      <div className="breakup-box__details">
                        <h6 className={`breakup-box__title breakup-box__title--`}>
                          {getValue(overViewInfo, `location_count`, "0")}
                        </h6>
                        <p
                          className={`breakup-box__text breakup-box__text--${"green-color"}`}
                        >
                          {textCapitalize("Locations")}
                        </p>
                      </div>
                      <img
                        src={`/images/dashboard/vender-audit/beenhere.svg`}
                        className="img-fluid breakup-box-image"
                        alt="img"
                      />
                    </section>
                  </div>

                  <div className="overview-wrapper__header d-flex align-items-center justify-content-between">
                    <h3 className="overview-wrapper__header-title">
                      Average Audit Score -{" "}
                      <span>
                        {formatDecimal(
                          getValue(summaryInfo, `auditScore.compliance_score`, "")
                        )}
                        %
                      </span>
                    </h3>

                    <div className="filter-form-wrappper__container">
                      {/* <div>
                      <DatePicker
                        onChange={setDate}
                        value={date}
                        format="MMM yyyy"
                        disableCalendar={true}
                        yearAriaLabel={"yyyy"}
                      />
                      <button className="header-btn" onClick={handleSubmitDate}>
                        Apply
                      </button>
                    </div> */}
                      <CalenderDropdown
                        value={date}
                        onChange={setDate}
                        handleSubmitDate={handleSubmitDate}
                      />
                    </div>
                  </div>
                  <div className="d-flex align-items-center box-gap">
                    <section
                      className={`breakup-box breakup-box--${"green-color"} breakup-box--`}
                      onClick={() =>
                        getValue(summaryInfo, `summery.uploaded_count`, 0) > 0 &&
                        handleNavigateUpload("UPLOADED")
                      }
                    >
                      <div className="breakup-box__details">
                        <h6 className={`breakup-box__title breakup-box__title--`}>
                          {getValue(summaryInfo, `summery.uploaded_count`, "0")}
                        </h6>
                        <p className={`breakup-box__text breakup-box__text--`}>
                          {textCapitalize("Uploaded")}
                        </p>
                      </div>
                      <img
                        src={`/images/dashboard/vender-audit/engineering.svg`}
                        className="img-fluid breakup-box-image"
                        alt="img"
                      />
                    </section>
                    <section
                      className={`breakup-box breakup-box-- breakup-box--`}
                      onClick={() =>
                        getValue(summaryInfo, `summery.not_uploaded_count`, 0) >
                          0 && handleNavigateUpload("NOT_UPLOADED")
                      }
                    >
                      <div className="breakup-box__details">
                        <h6 className={`breakup-box__title breakup-box__title--`}>
                          {getValue(
                            summaryInfo,
                            `summery.not_uploaded_count`,
                            "0"
                          )}
                        </h6>
                        <p
                          className={`breakup-box__text breakup-box__text--${"blue-color"}`}
                        >
                          {textCapitalize("Not Uploaded")}
                        </p>
                      </div>
                      <img
                        src={`/images/dashboard/vender-audit/beenhere.svg`}
                        className="img-fluid breakup-box-image"
                        alt="img"
                      />
                    </section>
                  </div>
                  <div className="overview-wrapper__header d-flex align-items-center justify-content-between">
                    <h3 className="overview-wrapper__header-title">
                      {"Uploaded Audit Breakup"}
                    </h3>
                  </div>
                  <div className="d-flex align-items-center box-gap">
                    <section
                      className={`breakup-box breakup-box--${"red-color"} breakup-box--`}
                      onClick={() =>
                        getValue(summaryInfo, `summery.pending_audit_count`, 0) >
                          0 && handleNavigateAudit("PENDING_AUDIT")
                      }
                    >
                      <div className="breakup-box__details">
                        <h6 className={`breakup-box__title breakup-box__title--`}>
                          {getValue(
                            summaryInfo,
                            `summery.pending_audit_count`,
                            "0"
                          )}
                        </h6>
                        <p className={`breakup-box__text breakup-box__text--`}>
                          {textCapitalize("Pending Audit")}
                        </p>
                      </div>
                      <img
                        src={`/images/dashboard/vender-audit/upcomming.svg`}
                        className="img-fluid breakup-box-image"
                        alt="img"
                      />
                    </section>
                    <section
                      className={`breakup-box breakup-box--${"green-color"} breakup-box--`}
                      onClick={() =>
                        getValue(summaryInfo, `summery.complied_count`, 0) > 0 &&
                        handleNavigateAudit("COMPLIED")
                      }
                    >
                      <div className="breakup-box__details">
                        <h6 className={`breakup-box__title breakup-box__title--`}>
                          {getValue(summaryInfo, `summery.complied_count`, "0")}
                        </h6>
                        <p className={`breakup-box__text breakup-box__text--`}>
                          {textCapitalize("Complied")}
                        </p>
                      </div>
                      <img
                        src={`/images/dashboard/vender-audit/check.svg`}
                        className="img-fluid breakup-box-image"
                        alt="img"
                      />
                    </section>
                    <section
                      className={`breakup-box breakup-box--${"red-color"} breakup-box--`}
                      onClick={() =>
                        getValue(summaryInfo, `summery.non_complied_count`, 0) >
                          0 && handleNavigateAudit("NON_COMPLIED")
                      }
                    >
                      <div className="breakup-box__details">
                        <h6 className={`breakup-box__title breakup-box__title--`}>
                          {getValue(
                            summaryInfo,
                            `summery.non_complied_count`,
                            "0"
                          )}
                        </h6>
                        <p className={`breakup-box__text breakup-box__text--`}>
                          {textCapitalize("Non-Complied")}
                        </p>
                      </div>
                      <img
                        src={`/images/dashboard/vender-audit/cancel.svg`}
                        className="img-fluid breakup-box-image"
                        alt="img"
                      />
                    </section>
                    <section
                      className={`breakup-box breakup-box--${"red-color"} breakup-box--`}
                      onClick={() =>
                        getValue(
                          summaryInfo,
                          `summery.partially_complied_count`,
                          0
                        ) > 0 && handleNavigateAudit("PARTIALLY_COMPLIED")
                      }
                    >
                      <div className="breakup-box__details">
                        <h6 className={`breakup-box__title breakup-box__title--`}>
                          {getValue(
                            summaryInfo,
                            `summery.partially_complied_count`,
                            "0"
                          )}
                        </h6>
                        <p className={`breakup-box__text breakup-box__text--`}>
                          {textCapitalize("Partially Complied")}
                        </p>
                      </div>
                      <img
                        src={`/images/dashboard/vender-audit/flacky.svg`}
                        className="img-fluid breakup-box-image"
                        alt="img"
                      />
                    </section>
                    <section
                      className={`breakup-box breakup-box--${"orange-color"} breakup-box--`}
                      onClick={() =>
                        getValue(summaryInfo, `summery.not_applicable_count`, 0) >
                          0 && handleNavigateAudit("NOT_APPLICABLE")
                      }
                    >
                      <div className="breakup-box__details">
                        <h6 className={`breakup-box__title breakup-box__title--`}>
                          {getValue(
                            summaryInfo,
                            `summery.not_applicable_count`,
                            "0"
                          )}
                        </h6>
                        <p className={`breakup-box__text breakup-box__text--`}>
                          {textCapitalize("Not Applicable")}
                        </p>
                      </div>
                      <img
                        src={`/images/dashboard/vender-audit/block.svg`}
                        className="img-fluid breakup-box-image"
                        alt="img"
                      />
                    </section>
                    <section
                      className={`breakup-box breakup-box--${"red-color"} breakup-box--`}
                      onClick={() =>
                        getValue(
                          summaryInfo,
                          `summery.send_back_to_vendor_count`,
                          0
                        ) > 0 && handleNavigateAudit("SEND_BACK_TO_VENDOR")
                      }
                    >
                      <div className="breakup-box__details">
                        <h6 className={`breakup-box__title breakup-box__title--`}>
                          {getValue(
                            summaryInfo,
                            `summery.send_back_to_vendor_count`,
                            "0"
                          )}
                        </h6>
                        <p className={`breakup-box__text breakup-box__text--`}>
                          {textCapitalize("Sent Back to Vendor")}
                        </p>
                      </div>
                      <img
                        src={`/images/dashboard/vender-audit/forward.svg`}
                        className="img-fluid breakup-box-image"
                        alt="img"
                      />
                    </section>
                  </div>

                  <div className="w-100">
                    <div className="loaction-wise-wrapper">
                      <div className="overview-wrapper__header d-flex align-items-center justify-content-between overview-wrapper__header-sm-mb">
                        <h3 className="overview-wrapper__header-title">
                          Location Wise Compliance Status
                        </h3>
                        <div className="loaction-wise-list">
                          <ul className="d-flex align-items-center">
                            <li className="loaction-wise-list-item">
                              Non-Compliant
                            </li>
                            <li className="loaction-wise-list-item">Compliant</li>
                          </ul>
                        </div>
                      </div>
                      <div className="vendor-graph">
                        <Bar options={options} data={data} height={70} />
                      </div>
                      <div className="overview-wrapper__header vendor-graph-border p-3 m-0 rounded-bottom">
                        <div className="filter-form-wrappper__container d-flex">
                          <div className="filter-form-wrappper__location-form-group form-group mb-0">
                            <div className="grid">
                              <div className="input-grid-item mt-0">
                                <label
                                  htmlFor="State"
                                  className="filter-form-wrappper__label d-none"
                                >
                                  State
                                </label>
                                <div className="filter-form-wrappper__location-input">
                                  <InputField
                                    inputType="INPUT_REACT_SELECT_MODAL"
                                    placeholder="Choose State"
                                    className="form-control w-100"
                                    name="state_id"
                                    id="state_id"
                                    // label="Last Name"
                                    options={states}
                                    value={state_ID}
                                    onChange={(e: any) =>
                                      handleChangeSelect(e, "state_id")
                                    }
                                    isClear
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="w-100">
                    <div className="loaction-wise-wrapper">
                      <div className="overview-wrapper__header d-flex align-items-center justify-content-between">
                        <h3 className="overview-wrapper__header-title">
                          Month Wise Compliance Status
                        </h3>
                        <div className="loaction-wise-list">
                          <ul className="d-flex align-items-center">
                            <li className="loaction-wise-list-item">
                              Non-Compliant
                            </li>
                            <li className="loaction-wise-list-item">Compliant</li>
                          </ul>
                        </div>
                      </div>
                      <div className="vendor-graph">
                        <Bar options={options} data={monthData} height={70} />
                      </div>
                    </div>
                  </div>
                  <div className="w-100">
                    <div className="loaction-wise-wrapper">
                      <div className="overview-wrapper__header d-flex align-items-center justify-content-between">
                        <h3 className="overview-wrapper__header-title">
                          Category Wise Compliance Status
                        </h3>
                        <div className="loaction-wise-list">
                          <ul className="d-flex align-items-center">
                            <li className="loaction-wise-list-item">
                              Non-Compliant
                            </li>
                            <li className="loaction-wise-list-item">Compliant</li>
                          </ul>
                        </div>
                      </div>
                      <div className="vendor-graph">
                        <Bar options={options} data={categoryData} height={70} />
                      </div>
                    </div>
                  </div>
                  <br />
                  <div className="w-100">
                    <div className="loaction-wise-wrapper">
                      <div className="overview-wrapper__header d-flex align-items-center justify-content-between">
                        <h3 className="overview-wrapper__header-title">
                          Location Wise Audit Uploaded
                        </h3>
                        <div
                          className=" d-block justify-content-center cursor-pointer"
                          onClick={handleDownloadSelfComplianceReport}
                        >
                          <img
                            src="/images/download-gray.svg"
                            style={{
                              height: "24px",
                              width: "24px",
                              margin: "0px auto",
                              marginLeft: "22px",
                            }}
                          />
                          <p style={{ fontSize: "10px" }}>
                            {downloadLoading ? "Please wait..." : "DOWNLOAD"}
                          </p>
                        </div>
                      </div>
                      <ExpandableTable
                        auditUploadLocations={auditUploadLocations}
                        handleClickRow={getAuditUploadLcoationVendorData}
                        vendorsByLocation={vendorsByLocation}
                        headers={[
                          "Location",
                          "Uploaded",
                          "NotUploaded",
                          "Complied",
                          "Not Complied",
                          "Not Applicable",
                          "Partially Complied",
                          "Score",
                        ]}
                      />
                    </div>
                  </div>
                  <div className="w-100">
                    <div className="loaction-wise-wrapper">
                      <div className="overview-wrapper__header d-flex align-items-center justify-content-between">
                        <h3 className="overview-wrapper__header-title">
                          Vendor Wise Audit Uploaded
                        </h3>
                        <div
                          className=" d-block justify-content-center cursor-pointer"
                          onClick={handleDownloadSelfComplianceReport1}
                        >
                          <img
                            src="/images/download-gray.svg"
                            style={{
                              height: "24px",
                              width: "24px",
                              margin: "0px auto",
                              marginLeft: "22px",
                            }}
                          />
                          <p style={{ fontSize: "12px" }}>
                            {downloadLoading1 ? "Please wait..." : "DOWNLOAD"}
                          </p>
                        </div>
                      </div>
                      <ExpandableTable
                        auditUploadLocations={auditUploadVendor}
                        handleClickRow={getAuditUploadVendorCityDataInside}
                        vendorsByLocation={locationsByVendor}
                        headers={[
                          "Location",
                          "Uploaded",
                          "NotUploaded",
                          "Complied",
                          "Not Complied",
                          "Not Applicable",
                          "Partially Complied",
                          "Score",
                        ]}
                      />
                    </div>
                  </div>
                </section>
                <div className="text-right">
                  <img
                    src="/images/profile-illustration.svg"
                    className="img-fluid"
                    alt="img"
                  />
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </DashboardLayout>
  );
}
